 'use client';
import React from 'react';
import GetStartedButton from "@/app/components/Utils/GetStartedButton";

export default function HeroSectionApps() {
    return (
        <section
            className="relative isolate overflow-hidden bg-white -mt-[74px] pt-[88px]"
            aria-labelledby="hero-heading"
        >
            <div className="mx-auto w-full max-w-7xl py-90 sm:py-90 lg:py-90 text-center">
                <div className="px-6 sm:px-8 mx-auto max-w-5xl">
                    <h1
                        id="hero-heading"
                        className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-center tracking-tight text-black"
                        aria-label="Cross-Platform Mobile & Desktop Applications"
                    >
                        <div className="block">
                            Cross Platform Mobile & Desktop Applications
                        </div>
                    </h1>

                    {/* Veteran-owned text below title */}
                    <p className="mx-auto mt-4 max-w-md text-lg text-gray-900 sm:text-xl md:mt-6 md:max-w-3xl">
                        100% Veteran Owned & Made in America
                    </p>

                    {/* Main description with better, more concise text */}
                    <p className="mx-auto mt-2 max-w-md text-base text-gray-700 sm:text-lg md:max-w-3xl">
                        Build high performance, scalable applications that run seamlessly across iOS, Android, Windows,
                        macOS, and Linux. Our cross platform development approach delivers native like experiences, fast
                        performance, and deep system integrations. 100% Veteran owned made in America.
                    </p>

                    <div className="mt-6 flex justify-center">
                        <GetStartedButton/>
                    </div>
                </div>
            </div>
        </section>
    );
}